import styled from 'styled-components';

export const StepContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
`;

export const StepIndicator = styled.div`
    align-items: center;
    border: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    color: #FFFFFF;
    display: flex;
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 700;
    height: 50px;
    justify-content: center;
    width: 50px;
`;

export const StepHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StepTitle = styled.h2`
    color: #FFFFFF;
    opacity: 1;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    text-align: center;
`;

export const StepDescription = styled.p`
    color: rgba(255, 255, 255, 0.1);
    font-size: 16px;
    margin: 0;
    text-align: center;
`;
